import {castArray, isNil, size} from 'lodash-es';

import {AbstractControl, ValidationErrors} from '@angular/forms';

export class UniqueValueValidator {
  public static readonly nonUniqueError = 'nonUniq';

  public static uniqueValue(control: AbstractControl): ValidationErrors | null {
    const {value} = control;

    if (isNil(value)) {
      return null;
    }

    const duplicatedValuesIdx = UniqueValueValidator.hasDuplicates(value);

    return size(duplicatedValuesIdx) ? {
      [UniqueValueValidator.nonUniqueError]: {
        actualValue: value,
        duplicatedIdx: duplicatedValuesIdx
      }
    } : null;
  }

  private static hasDuplicates(value: string[]): number[] {
    const controlValues = castArray(value);
    const idx: number[] = [];
    const encounteredIndices = {};

    if (controlValues) {
      controlValues.forEach((item, i) => {
        if (encounteredIndices[item]) {
          idx.push(i);
        } else {
          encounteredIndices[item] = 1;
        }
      });
    }
    return idx;
  }
}
